module.exports = __webpack_public_path__ + "static/media/whatsapp.f50bc621.png";